export default "__VITE_ASSET__t0njy6n1__"